import { FC, useMemo } from 'react';
import { useCategoryRelationOptions } from './useCategoryRelationOptions';

export interface CategoryRelationSelectPreviewProps {
  selectedValue: string;
  isCombinedGroups: boolean;
}

export const CategoryRelationSelectPreview: FC<
  CategoryRelationSelectPreviewProps
> = (props) => {
  const { selectedValue, isCombinedGroups } = props;
  const options = useCategoryRelationOptions(isCombinedGroups);

  const selectedCategoryName = useMemo(
    () => options.find((o) => o.value === selectedValue)?.label,
    [options]
  );

  return selectedCategoryName || selectedValue;
};
